/* ici21 — product page behaviours (variant pills, bundle, gallery, sticky bar).
   Reuses Expanse's drawer cart via the ajaxProduct:added event. */
(function () {
  "use strict";
  function ready(fn){ if(document.readyState!=="loading") fn(); else document.addEventListener("DOMContentLoaded", fn); }

  ready(function () {
    var root = document.querySelector("[data-ici21x]");
    if (!root) return;

    /* ---------- data ---------- */
    var variants = [];
    try { variants = JSON.parse(root.querySelector("[data-ici21x-variants]").textContent); } catch (e) {}
    var moneyFmt = root.getAttribute("data-money-format") || "£{{amount}}";
    function money(cents){
      var v = (cents/100).toFixed(2);
      return moneyFmt.replace("{{amount}}", v).replace("{{amount_no_decimals}}", Math.round(cents/100));
    }

    /* selected option values, seeded from the first available variant */
    var seed = null;
    for (var i=0;i<variants.length;i++){ if(variants[i].available){ seed = variants[i]; break; } }
    if(!seed) seed = variants[0] || {options:[]};
    var chosen = (seed.options||[]).slice();

    function resolve(){
      for (var i=0;i<variants.length;i++){
        var o = variants[i].options||[];
        var ok = true;
        for (var j=0;j<chosen.length;j++){ if(o[j]!==chosen[j]){ ok=false; break; } }
        if(ok) return variants[i];
      }
      return null;
    }

    /* ---------- price + bundle ---------- */
    var priceNow = root.querySelector("[data-ici21x-price-now]");
    var priceWas = root.querySelector("[data-ici21x-price-was]");
    var cta       = root.querySelector("[data-ici21x-add]");
    var ctaLabel  = root.querySelector("[data-ici21x-add-label]");
    var stickyMeta= root.querySelector("[data-ici21x-sticky-price]");
    var stickyVar = root.querySelector("[data-ici21x-sticky-variant]");

    var qtyInput = root.querySelector("[data-ici21x-qty]");
    function bundleQty(){
      var n = parseInt(qtyInput && qtyInput.value, 10);
      return (n && n > 0) ? n : 1;
    }
    function bundleDisc(){ var q=bundleQty(); return q>=3?20:(q>=2?15:0); }  // real: 2+ ->15%, 3+ ->20%
    function setQty(n){
      n = Math.max(1, parseInt(n, 10) || 1);
      if(qtyInput) qtyInput.value = n;
      refresh();
    }

    function baseName(url){
      return (url||"").split("?")[0].split("/").pop().replace(/_(\d+x\d*|pico|icon|thumb|small|compact|medium|large|grande|original|master)(?=\.)/i,"");
    }
    function flipImage(v){
      if(!v || !v.featured_image || !v.featured_image.src) return;
      var mi = root.querySelector("[data-ici21x-main]");
      if(mi) mi.src = v.featured_image.src;
      var vb = baseName(v.featured_image.src);
      root.querySelectorAll(".ici21x__thumb").forEach(function(b){
        var match = baseName(b.getAttribute("data-full")) === vb;
        b.classList.toggle("is-active", match);
        if(match && b.classList.contains("ici21x__thumb--more")){
          root.querySelectorAll(".ici21x__thumb").forEach(function(x){ x.style.display=""; });
          var lbl=b.querySelector(".ici21x__thumb-morelabel"); if(lbl) lbl.remove();
          b.classList.remove("ici21x__thumb--more");
        }
      });
    }

    function refresh(){
      var v = resolve();
      // pill availability
      root.querySelectorAll(".ici21x__pill").forEach(function(p){
        p.classList.toggle("is-selected", chosen[+p.getAttribute("data-opt")] === p.getAttribute("data-value"));
      });
      flipImage(v);
      var qty = bundleQty(), disc = bundleDisc();
      root.querySelectorAll("[data-ici21x-deal]").forEach(function(d){
        d.classList.toggle("is-on", parseInt(d.getAttribute("data-disc"),10) === disc);
      });
      if(v){
        var unit = v.price;
        var total = Math.round(unit*qty*(100-disc)/100);
        if(priceNow) priceNow.textContent = money(unit);
        if(priceWas){
          if(v.compare_at_price && v.compare_at_price>unit){ priceWas.textContent = money(v.compare_at_price); priceWas.style.display=""; }
          else priceWas.style.display="none";
        }
        if(ctaLabel) ctaLabel.textContent = "Add to bag — " + money(total);
        if(stickyMeta) stickyMeta.textContent = money(total);
        if(stickyVar) stickyVar.textContent = (v.title && v.title!=="Default Title") ? v.title : "";
        if(cta){
          cta.disabled = !v.available;
          if(!v.available && ctaLabel) ctaLabel.textContent = "Sold out";
        }
      } else {
        if(ctaLabel) ctaLabel.textContent = "Unavailable";
        if(cta) cta.disabled = true;
      }
    }

    root.querySelectorAll(".ici21x__pill").forEach(function(p){
      p.addEventListener("click", function(){
        if(p.classList.contains("is-unavailable")) return;
        chosen[+p.getAttribute("data-opt")] = p.getAttribute("data-value");
        refresh();
      });
    });
    var qMinus = root.querySelector("[data-ici21x-qtyminus]");
    var qPlus  = root.querySelector("[data-ici21x-qtyplus]");
    if(qMinus) qMinus.addEventListener("click", function(){ setQty(bundleQty()-1); });
    if(qPlus)  qPlus.addEventListener("click", function(){ setQty(bundleQty()+1); });
    if(qtyInput){
      qtyInput.addEventListener("input", function(){ qtyInput.value = qtyInput.value.replace(/[^0-9]/g,""); refresh(); });
      qtyInput.addEventListener("blur", function(){ setQty(qtyInput.value); });
    }
    root.querySelectorAll("[data-ici21x-grab]").forEach(function(b){
      b.addEventListener("click", function(){ setQty(b.getAttribute("data-ici21x-grab")); });
    });

    /* ---------- gallery ---------- */
    var mainImg = root.querySelector("[data-ici21x-main]");
    root.querySelectorAll(".ici21x__thumb").forEach(function(btn){
      btn.addEventListener("click", function(){
        // "+N" tile: reveal all hidden thumbnails, then behave like a normal thumb
        if(btn.classList.contains("ici21x__thumb--more")){
          root.querySelectorAll(".ici21x__thumb").forEach(function(b){ b.style.display=""; });
          var lbl = btn.querySelector(".ici21x__thumb-morelabel");
          if(lbl) lbl.remove();
          btn.classList.remove("ici21x__thumb--more");
        }
        var full = btn.getAttribute("data-full");
        if(mainImg && full) mainImg.src = full;
        root.querySelectorAll(".ici21x__thumb").forEach(function(b){ b.classList.remove("is-active"); });
        btn.classList.add("is-active");
      });
    });

    /* ---------- add to cart ---------- */
    function addToCart(trigger){
      var v = resolve();
      if(!v || !v.available) return;
      var items = [{ id: v.id, quantity: bundleQty() }];
      var orig = trigger.innerHTML;
      trigger.classList.add("is-loading"); trigger.disabled = true;
      var restore = function(){ trigger.classList.remove("is-loading"); trigger.disabled=false; trigger.innerHTML=orig; };
      fetch("/cart/add.js", {
        method:"POST",
        headers:{ "Content-Type":"application/json", "Accept":"application/json" },
        body: JSON.stringify({ items: items, sections:"cart-ajax", sections_url: window.location.pathname })
      }).then(function(r){ if(!r.ok) throw new Error("add"); return r.json(); })
        .then(function(data){
          restore();
          trigger.dispatchEvent(new CustomEvent("ajaxProduct:added", { bubbles:true, detail:{ product:data, addToCartBtn:trigger } }));
        })
        .catch(function(){ restore(); alert("Sorry, something went wrong adding to your bag."); });
    }
    if(cta) cta.addEventListener("click", function(){ addToCart(cta); });
    var stickyBtn = root.querySelector("[data-ici21x-sticky-add]");
    if(stickyBtn) stickyBtn.addEventListener("click", function(){ addToCart(stickyBtn); });

    /* ---------- sticky mobile bar visibility ---------- */
    var sticky = root.querySelector("[data-ici21x-sticky]");
    if(sticky && cta && "IntersectionObserver" in window){
      var io = new IntersectionObserver(function(entries){
        entries.forEach(function(en){
          var past = !en.isIntersecting && en.boundingClientRect.top < 0;
          sticky.classList.toggle("is-on", past);
        });
      }, { threshold:0 });
      io.observe(cta);
    }

    refresh();
  });
})();
